import { render, staticRenderFns } from "./item-form.vue?vue&type=template&id=0e47dcdd&scoped=true"
import script from "./item-form.vue?vue&type=script&lang=js"
export * from "./item-form.vue?vue&type=script&lang=js"
import style0 from "./item-form.vue?vue&type=style&index=0&id=0e47dcdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47dcdd",
  null
  
)

export default component.exports